// V

ready(qs('.CP-main-actus-wrapper'), () => {
    const $cp = qs('.CP-main-actus-wrapper');
    const $plusBtn = qs($cp, '.CP-plus');
    const $pushes = qsa($cp, '.CP-actus-wrapper li');
    const LIMIT_ITEMS = 3;

    const displayPushes = (forceAll) => {
        let limit = (forceAll ? $pushes.length : LIMIT_ITEMS);
        let i = 0;
        for (; i < limit; i++) {
            if ($pushes[i]) {
                $pushes[i].style.display = 'block';
            }
            else {
                clearButton();
            }
        }

        if(!$pushes[i]){
            clearButton();
        }
    }

    const clearButton = () => {
        $plusBtn.style.display = 'none'
        $pushes[$pushes.length - 1].style.marginBottom = "30px";
    }

    // first time on load
    displayPushes(false);

    click($plusBtn, () => {
        // and on click on the plus btn
        displayPushes(true);
    })
});


// WEBPACK FOOTER //
// ./src/scripts/components/MainActusWrapper.js